import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DialogService } from '@blaze-shared/shared-feature';
import { ConfirmDialogButton, ConfirmDialogButtonAction } from '@blaze-shared/workflow-domain';

export interface DialogConfirmInput {
  title: string;
  message: string;
  messageFormat?: 'markdown' | 'html';
  buttons: ConfirmDialogButton[];
}

@Component({
  selector: 'blaze-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full' },
  standalone: false,
})
export class DialogConfirmComponent implements OnInit, OnDestroy {
  private dialogRef = inject<MatDialogRef<DialogConfirmComponent>>(MatDialogRef);
  private dialogService = inject(DialogService);
  dialogData = inject<DialogConfirmInput>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.dialogService.setDialogOpened(true);
  }

  ngOnDestroy(): void {
    this.dialogService.setDialogOpened(false);
  }

  action(action: ConfirmDialogButtonAction): void {
    this.dialogRef.close(action);
  }
}
